import { createRouter, createWebHistory } from 'vue-router';
import type { App } from 'vue';
import { basicRoutes } from './routes';

export const router = createRouter({
  history: createWebHistory(),
  routes: basicRoutes,
});

export function setupRouter(app: App<Element>) {
  app.use(router);
}
